import { useCallback } from "react";
import constate from "constate";

import { useSessionStorage } from "../../hooks";
import { AuthSession } from "../../api/OAuth2Client";

const useAuthSession = () => {
  const [authSession, startSession] = useSessionStorage<
    AuthSession | undefined
  >("App.AuthSession");

  const finishSession = useCallback(() => {
    startSession(undefined);
  }, [startSession]);

  return {
    authSession,
    startSession,
    finishSession,
  };
};

export const [AuthSessionProvider, useAuthSessionContext] = constate(
  useAuthSession,
);
